<template>
	<div class="d-block position-relative">
		<DashboardCard :header-title="title"
		               :refreshButton="true"
					   @refresh="refresh" >
			<PaginatedTable :table-data="tableData"
			                :multi-select="multiSelect"
			                :has-query-input="false"
			                :table-headers="tableHeaders"
			                :paginated="true"
			                :extra-inputs="extraInputs"
			                :date-search="false"
			                :search-model="searchModel"
							 @sort="(newContent)=>tableData={...newContent}"
			                @select="selectItem"
			                @next="loadSidePage(true)"
			                @previous="loadSidePage(false)"
			                @search="updateAndSearch"/>
			
			
			<div class="row mt-4" v-if="tableData.content.length>0">
				<div class="col-md-4">
					<Button label="Download Excel"
					        class="w-100"
					        icon="pi pi-download"
					        severity="warn"
					        @click="mailMerge"/>
				</div>
				
				<div class="col-md-4">
					<Button :label="!multiSelect ? 'Multi Select' : 'Deselect'"
					        class="w-100"
					        :icon="multiSelect ? 'pi pi-times' : 'pi pi-check'"
					        severity="info"
					        @click="toggleSelect"/>
				</div>
				
				<div class="col-md-4">
					<Button :label="'Communicate'"
					        class="w-100"
					        icon="pi pi-share"
					        severity="info"
					        @click="communicate"/>
				</div>
			</div>
		</DashboardCard>
	</div>
</template>


<script>
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";
import PaginatedTable from "@/dashboard/utils/paginator/PaginatedTable.vue";
import Button from "primevue/button";
import {PAGE_MODEL} from "@/utils/DEFAULT_MODELS";
import {AVAILABLE_LANGUAGES} from "@/dashboard/organization/Organization";
import {getDateFromTimeStamp, renameKey} from "@/utils/AppFx";

export default {
	name: "BirthdaysList",
	components: {PaginatedTable, DashboardCard, Button},
	data(){
		return {
			tableData: {...PAGE_MODEL},
			searchModel: {
				multiple: false,
				start: null,
				end: null,
				size: 5,
				page: 1
			},
			selectOptions: [
				{ label: "Single Date", value: false},
				{ label: "Date Gap", value: true},
			],
			multiSelect: false,
			selectedItems: new Set()
		}
	},
	computed: {
		title: function(){
			return this.isBirthday ? 'Birthdays' : 'Marriages Anniversaries';
		},
		extraInputs: function(){
			return [
				{ type: "SELECT", model: "multiple", placeholder: "Select", options: this.selectOptions, styleClass:'col-md-6 mb-4'},
				{ type: "DATE", model: "start", placeholder: "Date Start", format: "dd-MM", styleClass:'col-md-8 mb-4'},
				{ type: "DATE", model: "end", placeholder: "END DATE", format: "dd-MM", styleClass:'col-md-8 mb-4', shownIf: {model: "multiple", values: [true]}},
			].map(input=>{
				if(this.searchModel.multiple) input.styleClass = "col-md-4 mb-4";
				else input.styleClass = "col-md-6 mb-4";
				return input;
			});
		},
		isInstitutionChurch: function(){ return this.isChurch; },
		tableHeaders: function(){
			let headers = {
				"Full name":{
					rows:[
						{ type: "StringArray", attribute: ["firstName", "lastName"]},
						{ type: "Date", attribute: this.isBirthday ? "dob" : 'dom', label: this.isBirthday ? "DOB" : "DOM"},
						{ type: "String", attribute: "email"},
						{ type: "PlainNumber", attribute: "phone", label: "Phone: "}
					]
				},
				"Partner Code":{
					rows:[
						{ type: "String", attribute: "code"},
					]
				},
				"Info":{
					rows:[
						{ label:"State", type: "String", attribute: "state" },
						{ label:"District", type: "String", attribute: "district" },
						{ label:"Language", type: "Select", attribute: "language", options: [...AVAILABLE_LANGUAGES]},
					].filter(row=>{
						if(this.isInstitutionChurch) return row.attribute!=="subscription";
						return true
					})
				},
				"Created on":{
					rows:[
						{ type: "Date", attribute: "creationDate"}
					]
				}
			};
			if(this.isInstitutionChurch) headers = renameKey(headers, "Partner Code", "Member Code");
			return headers;
		},
		isListBirthDay: function(){
			return this.isBirthday;
		}
	},
	methods: {
		communicate: function(){
			this.$store.commit("setPeopleToCommunicate", [...this.selectedItems]);
			let url = this.isInstitutionChurch
				? "/church/communication"
				: "/organizations/communication";
			this.$router.push(url);
		},
		getExcelHeaders: function() {
    const headers = [
        "FIRST NAME", 
        "LAST NAME", 
        this.isInstitutionChurch ? "MEMBER CODE" : "PARTNER CODE",
        this.isBirthday ? "DOB" : "DOM",
        "EMAIL", 
        "PHONE NUMBER"
    ];
    return headers.join(',');
},

toCsvRow: function (item) {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            return typeof getDateFromTimeStamp === 'function'
                ? getDateFromTimeStamp(dateString, true)
                : new Date(dateString).toLocaleDateString('en-IN');
        } catch (e) {
            return dateString;
        }
    };

    const toUpperSafe = (value) =>
        value ? String(value).toUpperCase() : '';

    const dataRow = [
        `"${toUpperSafe(item.firstName)}"`,
        `"${toUpperSafe(item.lastName)}"`,
        `"${toUpperSafe(item.code)}"`,
        `"${toUpperSafe(formatDate(this.isBirthday ? item.dob : item.dom))}"`,
        `"${toUpperSafe(item.email)}"`,
        `"${toUpperSafe(item.phone)}"`
    ];

    return dataRow.join(',');
},


		toggleSelect: function(){
			if(this.multiSelect) {
				this.selectedItems = new Set();
				this.tableData = {
					...this.tableData,
					content: this.tableData.content.map(item=>{
						return {
							...item,
							isItemSelected: false
						}
					})
				}
				this.multiSelect = false;
			} else {
				this.multiSelect = true;
			}
		},
		loadSidePage: function(next = true){
    // This is for page navigation, so we increment/decrement the page.
    let page = next ? this.searchModel.page+1 : this.searchModel.page-1;
    if(page>this.tableData.totalPages || page<=0) return;
    this.searchModel = {
        ...this.searchModel,
        page: page // Here we keep the new page number
    }
    this.makeSearch();
},

		updateAndSearch: function(newSearchModel){
    // 1. Update local searchModel with new size/filter values
    this.searchModel = {...newSearchModel};


if(this.searchModel.multiple && this.searchModel.start && this.searchModel.end){

        const start = new Date(this.searchModel.start);
        const end = new Date(this.searchModel.end);

        if(end < start){
            this.$toast.add({
                severity: 'warn',
                summary: 'Invalid Date Range',
                detail: 'End date cannot be earlier than start date',
                life: 3000
            });
            return; // stop search if invalid
        }
    }

    // 🔥 2. Add the fix: If the filters or size changed, reset page to 1
    if (this.searchModel.page !== 1) { // Check if it's not already page 1
        this.searchModel.page = 1;
    }

    // You should probably check if *any* filter field changed (start, end, multiple, search query) 
    // and if so, reset the page. 
    // The safest way is to *always* reset the page on a new search/filter action.

    this.makeSearch(); 
},
		makeSearch: function(){
			let data = this.$root['addInstitutionId']({...this.searchModel});
			
			data = {
				...data,
				birthdayType: this.isBirthday ? "BIRTHDAY" : "MARRIAGE"
			}
			if(!data.multiple) data.end;
			this.$api.post("/institution/list-birthdays", data).then(response=>{
    
    const size = this.searchModel.size;
    const totalElements = response.totalElements;
    const correctTotalPages = Math.ceil(totalElements / size);

    this.tableData = {
        ...response,
        totalPages: correctTotalPages // Override the incorrect API value
    };
}).catch(error=>{
				this.$root['handleApiError'](error, this.title+" listing.");
			});
		},
		mailMerge: function () {
    this.$store.commit("setLoading", true);

    // 1. Prepare model to request ALL records (size: 167)
    let fullDataModel = { ...this.searchModel };
    const totalRecords = this.tableData.totalElements || 10000; 
    
    fullDataModel.size = totalRecords;
    fullDataModel.page = 1; 
    
    if(this.searchModel.sortField){
        fullDataModel.sortField = this.searchModel.sortField;
        fullDataModel.sortOrder = this.searchModel.sortOrder;
    }
    
    let data = this.$root['addInstitutionId'](fullDataModel);
    data = {
        ...data,
        birthdayType: this.isBirthday ? "BIRTHDAY" : "MARRIAGE",
		    actionType: "DOWNLOAD" 
    }
console.log("DOWNLOAD REQUEST DATA 👉", data);
    if(!data.multiple) data.end = undefined;

    // 2. New API call for ALL records
    this.$api.post("/institution/list-birthdays", data).then(response => {
        let csvRowString = "";
        
        // 🔥 Step A: Add HEADER ROW first.
        csvRowString += this.getExcelHeaders() + '\n'; 
        
        // 🔥 Step B: Loop through ALL records (response.content) and add data rows.
        response.content.forEach(singleRecord => {
            csvRowString += this.toCsvRow(singleRecord) + '\n'; 
        });

        // 3. Trigger Download (Browser API logic)
        const blob = new Blob([csvRowString], { type: 'text/csv' }),
            link = document.createElement('a');
       let eventName = this.isBirthday ? 'Birthdays' : 'Marriages';
        let fileName = getDateFromTimeStamp(new Date(), true) + '-' + eventName + '.csv';
        fileName = fileName.replaceAll(":", "_").replaceAll("/", "_");
        link.download = fileName;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$store.commit("setLoading", false); 
        
    }).catch(error => {
        this.$root['handleApiError'](error, "Download Excel failed. Check browser console for detailed error.");
        this.$store.commit("setLoading", false); 
    });
},
		selectItem: function(item){
			if(this.selectedItems.has(item)) this.selectedItems.delete(item);
			else this.selectedItems.add(item);
		},
		refresh: function(resetModel=true){
			if(resetModel) {
				this.searchModel = {
					multiple: false,
					start: null,
					end: null,
					size: 5,
					page: 1
				};
			}
			this.tableData = {...PAGE_MODEL};
			this.makeSearch();
		}
	},
	watch:{
		isChurch: function(ignored){ this.refresh() },
		isBirthday: function(ignored){ this.refresh(false) }
	},
	props: {
		isChurch: {
			type: Boolean,
			required: true,
			default(){
				return false;
			}
		},
		isBirthday: {
			type: Boolean,
			required: true,
			default(){
				return false;
			}
		},
	}
}
</script>

<style scoped lang="scss">

</style>